import React from 'react';
import { createGlobalStyle } from 'styled-components';

import { family, baseFontSize } from '../theme/typography';
import { pxToEm } from '../utils/units';
import { brand } from '../theme/colours';

const familyDefinitions = Object.values(family);

export const styles = `${familyDefinitions
  .flatMap(({ name, src }) =>
    src.map(
      ({ weight, sources }) => `@font-face {
  font-family: ${name};
  font-style: normal;
  font-weight: ${weight};
  font-display: swap;
  src: ${sources
    .map(({ format, url }) => `url('${url}') format('${format}')`)
    .join(', ')};
}`
    )
  )
  .join('\n\n')}

  @font-face {
    font-family: 'otta-icons';
    src: url('https://static.otta.com/fonts/icons/otta-icons.ce94d6b0f398368e8ccfc40b18d5c2cdf947b46ab3.ttf')
        format('embedded-opentype'),
      url('https://static.otta.com/fonts/icons/otta-icons.ce94d6b0f398368e8ccfc40b18d5c2cdf947b46ab3.woff2') format('woff2'),
      url('https://static.otta.com/fonts/icons/otta-icons.ce94d6b0f398368e8ccfc40b18d5c2cdf947b46ab3.woff') format('woff');
  }

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  font-size: ${pxToEm(baseFontSize)};
  font-family: ${family.body.name}, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
    'Helvetica Neue', sans-serif;
  line-height: 1.3;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

body {
  background: ${brand.grey};
}
`;

export const GlobalStyles = createGlobalStyle`
  ${styles}
`;

const fontsToPreload = familyDefinitions
  .flatMap((def) => def.src.flatMap((src) => src.sources))
  .filter(({ format }) => format === 'woff2');

export function Preload() {
  return (
    <>
      {fontsToPreload.map(({ format, url }) => (
        <link
          key={url}
          rel="preload"
          href={url}
          as="font"
          type={`font/${format}`}
          crossOrigin="anonymous"
        />
      ))}
    </>
  );
}
